(function () {'use strict';}());
angular.module("app").directive('chart', function($document,$timeout,$filter,$interval,AppService) {
    return {
      restrict: 'A',
      templateUrl: 'views/chart.html?version=1.0',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;

        $scope.$watch("currentFeedbackQuestions",function(value){
            $timeout(function(){updateView(value);},1000);
        });

        function updateView(value){
        	if(!value || !value.length) return;

        	var ctx = element.find("canvas").get(0).getContext("2d");
        	ctx.canvas.width = "100%";
			ctx.canvas.height = 300;

            trace("updatingview",generateData(value));
			
			var line = new Chart(ctx).Line(generateData(value), {responsive: true,
                    animation:false,
					maintainAspectRatio: false,
					scaleOverride: true,
					scaleSteps:6,
					showScale:true,
					scaleStepWidth:1,
					scaleStartValue:0,
					scaleGridLineColor : "rgba(255,255,255,0.2)",
					scaleShowHorizontalLines:true,
					scaleShowVerticalLines:false,
					pointDot : true,
					pointDotRadius : 5,
					pointDotStrokeWidth : 4,
					bezierCurve : false,
					scaleFontColor: "white",
					scaleLineColor: "rgba(255,255,255,0.2)",
					legendTemplate : "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<datasets.length; i++){%><li><span style=\"background-color:white\">test</span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>"});
        }

        function generateData(questions){
        	return {
	        	labels : ["Week 1","Week 2","Week 3","Week 4","Week 5","Week 6","Week 7","Week 8","Week 9","Week 10","Week 11","Week 12"],
	        	datasets: [{
	        		label:"Sample Label",
	        		fillColor : "rgba(220,220,220,0)",
					strokeColor : "#5a6bad",
					pointColor : "#23507d",
					pointStrokeColor : "#5a6bad",
					data: generateQuestionData(questions)
	        	}]
	        };
        }

        function generateQuestionData(questions){
        	var results = [null,null,null,null,null,null,null,null];
        	var type = questions[0].type;
        	var responses =  $filter('response')(AppService.assessmentResults,null,false,null,type);


        	for(var i = 0, count = responses.length; i < count; i++)
        	{
        		var item = responses[i];
        		var score = $scope.getAdjustedScore(item,item.response === null ? null : parseInt(item.response));
        		var index = item.week - 1;
        		if(!results[index]) results[index] = 0;
        		results[index] += score.value;
        	}

        	return results;
        }
        
      }  
    };
  });
